import { render, staticRenderFns } from "./tableActivesOrders.vue?vue&type=template&id=5d14fddb&scoped=true&"
import script from "./tableActivesOrders.vue?vue&type=script&lang=js&"
export * from "./tableActivesOrders.vue?vue&type=script&lang=js&"
import style0 from "./tableActivesOrders.vue?vue&type=style&index=0&id=5d14fddb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d14fddb",
  null
  
)

export default component.exports